import
{
    FC
} from "react";

import
{
    SystemStatus
} from "../../System/SystemStatus";

import
{
    AuthorizationGeoCoordinate,
    AuthorizationPlan,
    //AuthorizationPermission,
    AuthorizationReactSession,
    AuthorizationStatus,
    AuthorizationSystemAuthorization,
    AuthorizationWLanSSID
} from "../../Authorization";

import Main, { Props } from "./Main";





const System: FC<Props> = ({
    buttons = [],
    filter = false,
    activeFilter = false,
    onFilterOpen,
    isFilterOpen = false,
}) =>
{
    return (<Main
        buttons={buttons}
        filter={filter}
        activeFilter={activeFilter}
        onFilterOpen={onFilterOpen}
        isFilterOpen={isFilterOpen}
    >
        <AuthorizationPlan />
        <AuthorizationReactSession />
        <AuthorizationSystemAuthorization />
        <AuthorizationGeoCoordinate />
        <AuthorizationWLanSSID />
        {/* <AuthorizationPermission /> */}
        <AuthorizationStatus />
        <SystemStatus />
    </Main>);
};

export default System;